import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './drawer.scss';
import Icon from '../../Common/Icon';
import Button from '../../Common/Button';

class Drawer extends React.Component {
	constructor(props) {
		super(props);
		this.escFunction = this.escFunction.bind(this);
	}

	componentDidMount() {
		document.addEventListener('keydown', this.escFunction, false);
	}

	componentWillUnmount() {
		this.cleanUp();
		document.removeEventListener('keydown', this.escFunction, false);
	}

	escFunction(event) {
		if (event.key === 'Escape') {
			this.closeClick();
		}
	}

	cleanUp = () => {
		document.body.classList.remove('modal-open');
	};

	saveClick = (event) => {
		this.cleanUp();
		if (this.props.onSaveClick) {
			this.props.onSaveClick(event);
		}
	};

	closeClick = () => {
		this.cleanUp();
		if (this.props.onCancelClick) {
			this.props.onCancelClick();
		}
	};

	render() {
		let wideCheck = this.props.isWide ? ' drawer-wide' : '';
		let final = 'drawer active ' + wideCheck;

		return (
			<div className={final}>
				<div className='inner'>
					<header>
						<div className='row'>
							<div className={this.props.isMobile ? 'col-6' : this.props.isWide ? 'col-9' : 'col-8'}>
								<div className='drawer-title'>
									{React.isValidElement(this.props.title) ? (
										<div>{this.props.title}</div>
									) : (
										<div className='drawer-title-text'>{this.props.title}</div>
									)}
								</div>
							</div>
							<div className={this.props.isMobile ? 'col-6' : this.props.isWide ? 'col-3' : 'col-4'}>
								<div className='drawer-span menuButtons'>
									{this.props.menuButtons && (
										<Fragment>
											{this.props.menuButtons.map((menuButton) => {
												if (!this.props.currentDrawerKey || menuButton.key !== this.props.currentDrawerKey) {
													return menuButton;
												}
											})}
										</Fragment>
									)}
									<div className='menuButtonGroup'>
										<button name='close' type='button' className='btn' onClick={this.closeClick} alt='close popup'>
											<Icon name='times' />
										</button>
									</div>
								</div>
							</div>
						</div>
					</header>
					<section>
						<div className='container'>
							<br />
							{this.props.children}
						</div>
					</section>
				</div>
				<footer>
					{this.props.customFooter ? (
						this.props.customFooter
					) : (
						<div className='button-wrap'>
							{this.props.onSaveClick && (
								<Button
									type='button'
									bootstrapClass='drawer-button btn btn-primary button--save'
									onClick={this.saveClick}
									text={this.props.saveText ? this.props.saveText : 'Save'}
									isDisabled={this.props.isSaveDisabled}
								/>
							)}
							{this.props.formButtons ? this.props.formButtons.map((formButton) => formButton) : null}
							<Button
								type='button'
								bootstrapClass='drawer-button btn btn-light button--cancel'
								onClick={this.closeClick}
								text={this.props.cancelText ? this.props.cancelText : 'Cancel'}
							/>
						</div>
					)}
				</footer>
			</div>
		);
	}
}

Drawer.propTypes = {
	isWide: PropTypes.bool.isRequired,
	isMobile: PropTypes.bool,
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
	onSaveClick: PropTypes.func,
	saveText: PropTypes.string,
	isSaveDisabled: PropTypes.bool,
	onCancelClick: PropTypes.func,
	cancelText: PropTypes.string,
	menuButtons: PropTypes.array,
	currentDrawerKey: PropTypes.string,
	formButtons: PropTypes.array,
	customFooter: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
	children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
};

export default Drawer;
